import React from 'react';
import { getDB } from "../../index";
import { CategoriesProxy } from "../services/catalogServiceAPI/categoriesProxy";
import { Table, Button, Tag, Spin, Typography, Empty } from 'antd';

const { Title } = Typography;
const PAGE_SIZE = 10;

export class UsersFeedback extends React.Component {
    categoriesProxy = new CategoriesProxy();
    state = { allDocs: null, categories: null, currentPage: 1 };

    async componentDidMount() {
        const categories = await this.categoriesProxy.list();
        this.setState({ categories });

        const snapshot = await getDB().collection("feedback")
            .where('resolved', '==', false)
            .get();

        this.setState({ allDocs: snapshot.docs, currentPage: 1 });
    }

    getSortedDocs = () => {
        const { allDocs } = this.state;
        if (!allDocs) return [];
        return [...allDocs].sort((a, b) => {
            const d1 = a.data().creationDate;
            const d2 = b.data().creationDate;
            return d1 < d2 ? 1 : d1 > d2 ? -1 : 0;
        });
    }

    resolve = (id) => {
        const { allDocs } = this.state;
        const doc = allDocs.find(d => d.id === id);
        if (doc) {
            doc.ref.update({ resolved: true });
            const newDocs = allDocs.filter(d => d.id !== id);
            const totalPages = Math.max(1, Math.ceil(newDocs.length / PAGE_SIZE));
            this.setState({ allDocs: newDocs, currentPage: Math.min(this.state.currentPage, totalPages) || 1 });
        }
    }

    render() {
        const { allDocs, categories, currentPage } = this.state;

        if (allDocs === null || !categories) {
            return <div style={{ padding: 24 }}><Spin /></div>;
        }

        const categoryMap = Object.fromEntries(categories.map(c => [c.id, c.title]));

        const dataSource = this.getSortedDocs().map(doc => {
            const data = doc.data();
            return {
                key: doc.id,
                id: doc.id,
                creationDate: data.creationDate ? new Date(data.creationDate).toLocaleString() : 'n/a',
                category: categoryMap[data.categoryId] || data.categoryId,
                userId: data.userId || null,
                feedback: data.feedback,
            };
        });

        const columns = [
            { title: 'Date', dataIndex: 'creationDate', width: 180 },
            { title: 'Category', dataIndex: 'category', width: 160 },
            { title: 'User', dataIndex: 'userId', width: 120, render: v => v ? <Tag>{v}</Tag> : '—' },
            { title: 'Feedback', dataIndex: 'feedback' },
            {
                title: 'Action',
                width: 100,
                align: 'center',
                render: (_, record) => (
                    <Button size="small" onClick={() => this.resolve(record.id)}>
                        Resolve
                    </Button>
                ),
            },
        ];

        return (
            <div style={{ padding: 24 }}>
                <Title level={3}>User Feedback</Title>
                {dataSource.length === 0
                    ? <Empty description="No open feedback" />
                    : (
                        <Table
                            dataSource={dataSource}
                            columns={columns}
                            size="small"
                            showSorterTooltip={false}
                            pagination={{
                                current: currentPage,
                                pageSize: PAGE_SIZE,
                                total: dataSource.length,
                                onChange: page => this.setState({ currentPage: page }),
                                showTotal: (total) => `${total} items`,
                            }}
                        />
                    )
                }
            </div>
        );
    }
}
